import { INITIAL_USERS_SEARCH_PARAMS } from 'src/views/security/users/partials/Constants'
import { SET_USERS_SEARCH_PARAMS } from '../actions/actionType'

const initialState = {
  searchParams: INITIAL_USERS_SEARCH_PARAMS,
}

export default function UsersReducer(state = initialState, action) {
  switch (action.type) {
    case SET_USERS_SEARCH_PARAMS:
      return { ...state, searchParams: action.payload }
    default:
      return state
  }
}
